import React from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Typography from '@mui/material/Typography';
import { Box, Link, Paper, Button, Divider, IconButton, Drawer, List, ListItem, ListItemText, Accordion, AccordionActions, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InfoIcon from '@mui/icons-material/Info';
import Container from '../../../../../components/Container';
import Main from '../../../../../layouts/Main';
import { ClickAwayListener } from '@mui/base/ClickAwayListener';
import CloseIcon from '@mui/icons-material/Close';
import InfoItemBox from './InfoItemBox';
import { InfoItemBoxProps } from '../dataObjects/contentTypes';
import Grid from '@mui/material/Grid2';

const drawerWidth = 800;

interface Props {
    open: boolean; 
    handleDrawerClose: () => void;
}

const content: InfoItemBoxProps[] = [
{
  title: "How to Set Up Your Bank Account",
  blocks: [
    {
      type: "list",
      listType: "bullet",
      items: [
        {
          content: [
            { type: "text", content: "Your bank may ask you for a copy of your completed Statement of Organization (CPF 101)." }
          ]
        },
        {
          content: [
            { type: "text", content: "Candidates should contact their banks in advance for further information about the bank's requirements to open a campaign account." },
            { type: "text", content: "Unlike the Depository system, the campaign finance law does not have any special requirements about the type of account you open and your bank will not have any campaign finance reporting requirements." }
          ]
        },
        {
          content: [
            { type: "text", content: "Many banks require committees to obtain an " },
            { type: "link", text: "Employer Identification Number", url: "https://www.irs.gov/businesses/small-businesses-self-employed/apply-for-an-employer-identification-number-ein-online" },
            { type: "text", content: " (EIN) to open a campaign account. The IRS allows you to apply for an " },
            { type: "link", text: "EIN online", url: "https://www.irs.gov/businesses/small-businesses-self-employed/apply-for-an-employer-identification-number-ein-online" },
            { type: "text", content: ". (click " },
            { type: "link", text: "here", url: "https://ocpf.us/PublicSearch/ViewDocument?id=2844" },
            { type: "text", content: " for OCPF's instructions on how to obtain an EIN)" }
          ]
        },
        {
          content: [
            { type: "text", content: "Candidates and committees should also consult the " },
            { type: "link", text: "Massachusetts Department of Revenue", url: "https://www.mass.gov/orgs/massachusetts-department-of-revenue" },
            { type: "text", content: " for information on any state tax requirements that may be applicable." }
          ]
        }
      ]
    },
  ]
},
{
  title: "Additional Help & Information",
  blocks:[
    {
      type: "list",
      listType: "bullet",
      items:[
        {
          content: [
            { type: "text", content: "OCPF Memorandum " },
            { type: "link", text: "M-24-01", url: "https://ocpf2.blob.core.windows.net/pdf/legaldocs/M-24-03.pdf" },
            { type: "text", content: ": Information on obtaining a Federal ID number and filing tax returns for political committees." }
          ]
        }
      ]
    }
  ]
}
];

const BankNonDepository = (): JSX.Element => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });


  return (
      <div>
         <Box sx={{paddingBottom: 2}}>
        <Typography
              component="h1"
              variant="h4"
              align={'left'}
              data-aos={'fade-up'}
              gutterBottom
              sx={{
                fontWeight: 700,
              }}
              paddingTop={4}>
              Set Up Your Bank Account <Typography component="span" variant="caption" color="text.secondary">Non-Depository Candidates and Committees</Typography>
            </Typography>

            <Divider />
            </Box>
         {content.map((content, index) => (
          <InfoItemBox key={index} {...content} />
        ))}
      </div>
       
   
        
  );
};

export default BankNonDepository;
